<template>
    <div style="min-height: 100%; overflow-x: hidden; height: 100%; width: 100% " >
    <el-menu  style="min-height: 100%; border-right-width: 0"
             background-color="rgb(48,65,86)" text-color="#fff"
             :collapse-transition="false"
             :collapse="isCollapse"
             :v-show="logoTextShow"
             router
    >
      <div style="height: 60px; line-height: 60px; text-align: center" class="item">
        <img src="../../../assets/images/logo.png" alt="" style="width: 20px; position: relative; top: 5px;margin-right: 5px">
        <b style="color: white" v-show="!isCollapse">食用菌数据管理平台</b>
      </div>
  <!--    <el-menu-item index="1">-->
  <!--      <template slot="title"><i class="el-icon-house"></i>-->
  <!--      <span slot="title">主页</span>-->
  <!--      </template>-->
  <!--    </el-menu-item>-->
      <el-menu-item index="/backhome">
        <i class="el-icon-s-home"></i>
          <span slot="title">主页</span>
      </el-menu-item>
      <el-submenu index="2">
        <template slot="title"><i class="el-icon-message"></i>
          <span slot="title">系统管理</span>
        </template>
        <el-menu-item-group>
          <el-menu-item index="user" >用户管理</el-menu-item>
          <el-menu-item v-if="user.role === '超级管理员'" index="company">公司管理</el-menu-item>
          <el-menu-item v-if="user.role === '管理员' || user.role === '超级管理员'" index="greenhouse">大棚管理</el-menu-item>
        </el-menu-item-group>
      </el-submenu>
      
      
      
      
  
      <el-submenu index="6">
        <template slot="title"><i class="el-icon-menu"></i>
          <span slot="title">设备管理</span>
        </template>
          <el-menu-item index="/sensorDevice">传感器设备</el-menu-item>
          <el-menu-item index="/controlDevice">控制设备</el-menu-item>
          <el-menu-item v-if="user.role === '管理员' || user.role === '超级管理员'" index="/ezviz-device">录像设备</el-menu-item>
          <!-- 监控设备已移除：不再在侧边栏显示 -->
          <el-menu-item index="/mqttTest">MQTT测试</el-menu-item>
      </el-submenu>

      <el-submenu index="7">
        <template slot="title"><i class="el-icon-odometer"></i>
          <span slot="title">环境数据管理</span>
        </template>
        <el-menu-item index="/sensorDataNew">传感器数据</el-menu-item>
      </el-submenu>
      <!-- <el-menu-item index="qrcode">
        <i class="el-icon-message"></i>
          <span slot="title">二维码</span>
      </el-menu-item>
      <el-menu-item index="7">
        <i class="el-icon-message"></i>
          <span slot="title">经济评价模块</span>
      </el-menu-item> -->
    </el-menu>
    </div>
  </template>
  <script>
  export default {
    name: "Aside",
    data() {
      return {
        user: JSON.parse(localStorage.getItem("user") || '{}')
      }
    },
    props: {
      isCollapse: Boolean,
      logoTextShow:Boolean,
      sideWidth:Number,
    }
  }
  </script>
  
  <style scoped>
  
  </style>
  
  <style scoped>
  /* 强制隐藏监控设备菜单项（以防旧 bundle 或其它位置仍渲染） */
  .el-menu-item[index="/camera"] {
    display: none !important;
  }
  </style>
  